import styled, { css } from 'styled-components';

interface OverlayProps {
  show: boolean;
}

export const Overlay = styled.div<OverlayProps>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 0;
  width: 0;
  background: rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;

  ${(props) =>
    props.show &&
    css`
      backdrop-filter: blur(4px);
      width: 100vw;
      height: 100vh;
    `}
`;
